<template lang="pug">
div
  span.custom-title(:class="class_")
    span.pt-sans
      slot
</template>

<script>
export default {
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
    white: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "page",
      validator: (v) => ["page", "section", "large"].includes(v),
    },
    simple: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    class_() {
      return [
        this.dark && "custom-title-dark",
        this.white && "custom-title-white",
        `custom-title-${this.type}`,
        { section: "text-title", page: "text-h5", large: "text-h4" }[
          this.type
        ] || "text-h5",
        this.simple && "custom-title-simple",
      ];
    },
  },
};
</script>

<style>
.custom-title {
  font-weight: bold !important;
  padding: 0 12px;
  border-style: solid;
  border-color: var(--v-primary-base);
  color: var(--v-secondary-darken4);
  text-transform: uppercase;
}
.custom-title-dark {
  border-color: white;
  color: var(--v-primary-base);
}
.custom-title-white {
  border-color: white;
  color: white;
}
.custom-title-section {
  border-width: 0px 2px 0px 2px;
}
.custom-title-section > * {
  letter-spacing: 2px !important;
}
.custom-title-large,
.custom-title-page {
  border-width: 0px 3px 0px 3px;
}
.custom-title-large > *,
.custom-title-page > * {
  letter-spacing: 4px !important;
}
.custom-title-simple {
  border-right: 0px;
  border-color: inherit;
}
</style>
